import React from "react";
import { useTranslation } from "react-i18next";
import { IoCloseSharp } from "react-icons/io5";
import U2000ActionBtn from "../../../../../../u2000Core/components/buttons/U2000ActionBtn";

export interface U3121BillingSummaryDetailDlgFooterProps {
  onClose: () => void;
}

/** Pied de dialogue lecture seule : bouton Fermer (U2000ActionBtn), aligné sur U2000InfoDialog / U2000SaveCancelDialog readOnly. */
const U3121BillingSummaryDetailDlgFooter: React.FC<U3121BillingSummaryDetailDlgFooterProps> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <footer className="flex shrink-0 items-center justify-end gap-3 rounded-b-2xl border-t border-gray-200 bg-gray-50 px-6 py-4">
      <U2000ActionBtn label={t("dlgLblInfo")} icon={IoCloseSharp} handleClick={() => onClose()} />
    </footer>
  );
};

export default U3121BillingSummaryDetailDlgFooter;
